import { FormattedMessage, useIntl } from 'react-intl';

import InfoIcon from '@/assets/icons/information.svg';

import { Checkbox } from './checkbox';
import { Label } from './label';
import { Tooltip } from './tooltip';
import { Typography } from './typography';

interface AggregateDataCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  isDisabled?: boolean;
  label: React.ReactNode;
  tooltipContent?: React.ReactNode;
}

export function AggregateDataCheckbox({
  checked,
  onCheckedChange,
  isDisabled = false,
  label,
  tooltipContent,
}: AggregateDataCheckboxProps) {
  const intl = useIntl();

  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id="show-only-funnel-data"
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={isDisabled}
      />
      <Label htmlFor="show-only-funnel-data">
        <Typography variant="body1">
          {label ?? (
            <FormattedMessage defaultMessage="Include aggregate hires" />
          )}
        </Typography>
      </Label>
      {tooltipContent && (
        <Tooltip
          content={
            tooltipContent ??
            intl.formatMessage({
              defaultMessage:
                'For openings that share sourcing efforts, show the aggregate number of hires and budget spend across all openings in the hiring workflow',
            })
          }
        >
          <img src={InfoIcon} alt="Info" />
        </Tooltip>
      )}
    </div>
  );
}
